export default __webpack_public_path__ + "static/media/Star.a191003e.svg";